import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class ContractInfoAllApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'contract-info-all'
  }

  /**
   * 查询客户列表
   * @param customer
   * @constructor
   */
  public QueryMyCustomerList(customer:string){
    if(customer==''){
      return this.runAction('QueryMyCustomerListA-E22-M32-S108', {});
    }
    else{
      customer='%'+customer+'%';
      return this.runAction('QueryMyCustomerListB-E22-M32-S107', {customer});
    }
  }

  public updateContractNo(contractNo: string) {
    return this.send({contractNo:contractNo},"updateContractNo",this.Methods.GET)
  }

}